<template>
  <div
    class="product-info"
    v-bind:class="{ border: showRightBorder }"
    @click="productClick"
  >
    <div class="product-image-wrap">
      <img class="product-icon" v-lazy="item.goods_img_480"/>
    </div>
    <span class="product-title">{{ item.goods_name }}</span>
    <div class="product-bottom">
      <span class="price">${{ item.goods_promotion_price }}</span>
    </div>
    <div class="product-meta">
      <span>Sales {{ item.goods_salenum }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'IndexProductBody',
  data () {
    return {
      itemWidth: 0,
      itemHeight: 0,
      showRightBorder: this.index % 2 == 0
    }
  },
  props: ['item', 'index'],
  computed: {

  },
  methods: {
    productClick: function () {
      this.$router.push({ name: 'HomeGoodsdetail', query: { goods_id: this.item.goods_id } })
    }
  }
}
</script>
<style lang="scss" scoped>
.border {
	border-right: 1px solid #f5f5f5;
}
.product-info {
	/*display: flex;
	flex-direction: column;
	padding:0.5rem;
	justify-content: flex-end;
	border-bottom: 1px solid #f5f5f5;
	width:50%;box-sizing:border-box;*/
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-content: flex-start;
  border: 0 solid #000;
  margin: 0;
  padding: 0;
  min-width: 0;
  overflow: hidden;
  position: relative;
  width: 45.73333vw!important;
  margin-bottom: 5.33333vw;
  .product-image-wrap {
    position: relative;
    margin-bottom: 2.13333vw;
    width: 100%;
    height: 45.73333vw;
    overflow: hidden;
    border-radius: 1.6vw;
    background-color: #f4f4f4;
  }
	.product-icon {
    width: 100%;
    height: 100%;
    overflow: hidden;
    -o-object-fit: contain;
    object-fit: contain;
	}
	.product-title {
    display: block;
    width: 100%;
    font-size: 3.46667vw;
    height: 4.26667vw;
    line-height: 4.26667vw;
    color: #666;
    margin-bottom: 3.2vw;
    white-space: nowrap;
    overflow: hidden;
	  text-overflow: ellipsis;
	}
	.product-bottom {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    font-weight: 700;
    font-size: 4.26667vw;
    color: #111;
    margin-bottom: 1.06667vw;
    line-height: 5.33333vw;
    .price {
      color: #111827;
    }
	}
}
.product-meta {
  display: flex;
  justify-content: space-between;
  gap: 1.6vw;
  overflow: hidden;
  font-size: 2.93333vw;
  color: #687385;
  margin-bottom: 3.2vw;
  line-height: 4.26667vw;
  span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
